'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

let s = {
    selected: t.bool
}, m = Object.keys(s);
const ListItem = renderWithRef('ListItem', s, (t, r)=>{
    let { children: s, selected: p = false } = t, c = new Set();
    return p && c.add('swan-list-item-selected'), jsx(RenderComp, {
        root: "li",
        forwardedRef: r,
        classNames: c,
        props: t,
        propKeysToRemove: m,
        children: s
    });
});

export { ListItem };
